import { getApplication } from '@ms/yammer-libs-static-config';

export const useShouldUseTeamsFocusNavigation: () => boolean = () => {
  const appType = getApplication();
  const isTeamsPersonal = appType === 'YAMMER_TEAMS_PERSONAL_APP';

  return isTeamsPersonal;
};
